import { createLogic } from "redux-logic";
import axios from "axios";

import * as ActionTypes from "../../actions/actionTypes";
import * as controlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const getUserLogic = createLogic({
	type: ActionTypes.LOAD_METADATA,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		var api = axios.create({
			baseURL: constants.BASE_API_URL,
			timeout: 20000,
		});
		//timezones
		api.get("/lookups/timezones")
			.then(data => {
				dispatch(controlPanelActions.loadTimezonesSuccess(data.data));
				done();
			})
			.catch(error => {
				dispatch(controlPanelActions.loadTimezonesFail(error));
				done();
			});
	},
});

export default [getUserLogic];
